import React from 'react';
const CarDiagnostics = () => <div style={{padding:32}}>Оношилгоо (stub)</div>;
export default CarDiagnostics;
